import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'formly-file-upload-field',
  template: `
    <div>{{ props.label }}</div>
    <p-editor
      [style]="{ height: '150px' }"
      styleClass="mt-4"
      label="Enter description"
      placeholder="Enter description"
      [formControl]="$any(formControl)"
      [formlyAttributes]="field"
    >
    </p-editor>
  `
})
export class EditorFieldType extends FieldType {
  constructor() {
    super();
  }
}
